import type { HTMLAttributes } from 'react';

/**
 * Card padrão do Bow Redesign.
 * - rounded-3xl (24px) — refinada usa cantos generosos.
 * - sombra navy translúcida soft (Tailwind `shadow-soft` — definida em
 *   tailwind.config.ts).
 * - bg-white default; caller pode sobrescrever (`bg-bow-royal`,
 *   `bg-transparent`, etc). O regex preserva precedência quando uma
 *   classe `bg-*` custom é passada — sem isso o Tailwind decide pela
 *   ordem do CSS e o bg-white default ganha.
 */
export function Card({ className = '', ...rest }: HTMLAttributes<HTMLDivElement>) {
  const hasBg = /\bbg-/.test(className);
  return (
    <div
      className={`overflow-hidden rounded-3xl ${hasBg ? '' : 'bg-white'} p-5 shadow-soft ${className}`}
      {...rest}
    />
  );
}
